import {http} from '@/utils/http'


/**
 * 获取token
 */
export const getTextToken = () => {
    return http({
        method: 'POST',
        url: '/app/test/token'
    })
}
/**
 * 获取会员等级
 */
export const getInfo = () => {
    return http({
        method: 'POST',
        url: '/app/mine/info'
    })
}

/**
 * 发送登录短信
 * @param data 手机号和code
 */
export const sendCode = (data: { code: string, mobile: string }) => {
    return http({
        method: 'POST',
        url: '/app/mobile/sendCode',
        data,
    })
}

/**
 * H5方式登录-第三方用户ID
 * @param data 手机号和code
 */
export const postLoginAPI = (data: { code: string, mobile: string, openId?: string }) => {
    return http<{ token: string }>({
        method: 'POST',
        url: '/app/login/mobile',
        data,
    })
}


/**
 * 通过微信授权码进行登录
 *
 * @param data 包含微信授权码的对象
 * @returns 返回登录结果
 */
export function postLoginByWxCode(data: { code: string, channel: string }) {
    return http<{ token: string }>({
        method: 'POST',
        url: '/app/login/wx',
        data,
    })
}

/*
* 获取协议清单
* */
export const clientAgreementList = (clientId: string) => http<{ agreementName: string, agreementUrl: string }[]>({
    method: 'GET',
    url: `/app/agreement/list/${clientId}`
})